import utils from 'utils';
import { ANALYTICS } from 'constants';

/**
 * Generic Responsive Accordion Tabs Class
 */

export default class AccordionTabs {
  constructor(params) {
    const { container, onToggle } = params;

    this.container = container;
    this.toggleCallback = onToggle;
    this._expandedId = null;
    // if the DOM already has the `hidden` attribute on it, we want to be able to toggle it
    // when we open/close the drawer. Otherwise we dont want to add this attribute!
    this.useHiddenAttribute = container.querySelector('[hidden]');

    // Add Event Listener to Togglers
    this.container.addEventListener('click', e => {
      const toggler = e.target.closest('[aria-controls]');
      if (toggler && !toggler.parentElement.classList.contains('disabled')) {
        const controlsId = toggler.getAttribute('aria-controls');
        this.handleToggle(toggler, controlsId);
      }
    });
  }

  handleToggle = (toggler, id) => {
    const analyticsType = toggler.getAttribute('data-analytics-type') || ANALYTICS.DRAWER;
    const analyticsValue = toggler.getAttribute('data-analytics-value');
    const isExpanded = toggler.getAttribute('aria-expanded') === 'true';

    isExpanded ? this._hide(toggler, id) : this._show(toggler, id);
    utils.safeExecute(this.toggleCallback, toggler, id);

    // Analytics: If the needed data attributes are present in the DOM, fire off custom analytics.
    // Keep in mind if it _currenly_ `isExpanded` then the click is closing the drawer, otherwise
    // the drawer is opening...
    if (analyticsValue) {
      utils.analytics.interaction(
        analyticsType, // type
        analyticsValue?.toLowerCase(), // key
        isExpanded ? ANALYTICS.CLOSE : ANALYTICS.OPEN // value
      );
    }
  };

  _hide = (toggler, id) => {
    const drawer = this.container.querySelector(`#${id}`);
    const container = drawer.parentElement;
    const ariaLabel = toggler.getAttribute('aria-label');

    container.classList.remove('expanded');
    toggler.setAttribute('aria-expanded', 'false');

    // Update the aria-label (if relevant)
    if (ariaLabel) {
      toggler.setAttribute('aria-label', ariaLabel.replace('close', 'open'));
    }

    // Upate the hidden attribute
    if (this.useHiddenAttribute) {
      drawer.setAttribute('hidden', '');
    }

    this._expandedId = null;
  };

  _show = (toggler, id) => {
    const drawer = this.container.querySelector(`#${id}`);
    const container = drawer.parentElement;
    const ariaLabel = toggler.getAttribute('aria-label');

    container.classList.add('expanded');
    toggler.setAttribute('aria-expanded', 'true');

    // Update the aria-label (if relevant)
    if (ariaLabel) {
      toggler.setAttribute('aria-label', ariaLabel.replace('open', 'close'));
    }

    // Upate the hidden attribute
    if (this.useHiddenAttribute) {
      drawer.removeAttribute('hidden');
    }

    if (this._expandedId !== null) {
      const expandedToggler = this.container.querySelector(`[aria-controls=${this._expandedId}]`);
      this._hide(expandedToggler, this._expandedId);
    }

    this._expandedId = id;
  };
}
